export class Number {
    constructor(json_obj) {
        for (const key in json_obj) {
            this[key] = json_obj[key];
        }
    }
    format_for_selectform() {
        return {
            value: this.id,
            text: this.number
        };
    }
}
